export class Job {

  public id: string;
  public jobId: string;
  public jobName: string;
  public name: string;
  public type: string;
  public destination: string;
  public lastRunDate: Date;
  public nextRunDate: Date;
  public schedule: boolean;
  public cron_expression: any;
  public types: string[];

}
